module.exports = __webpack_public_path__ + "static/media/trust-guarantee.83fdfca7.png";